module.exports = __webpack_public_path__ + "img/jkp-radlje-svetel.png";